import { gql } from '@apollo/client'
import fragments from 'graphql/fragments'

// Remote
export const _ADD_INVESTOR = gql`
  mutation _AddInvestor($projectId: ID!, $input: InvestorInput!) {
    _addInvestor(projectId: $projectId, investorInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const ADD_INVESTOR = gql`
  mutation AddInvestor($projectId: ID!, $input: InvestorInput!) {
    addInvestor(projectId: $projectId, investorInput: $input) {
      ...Investor
    }
  }
  ${fragments.investor}
`

export const _ADD_INVESTORS = gql`
  mutation _AddInvestors($projectId: ID!, $inputs: [InvestorInput!]!) {
    _addInvestors(projectId: $projectId, investorInputs: $inputs) {
      ...Project
    }
  }
  ${fragments.project}
`

export const GET_INVESTORS = gql`
  query Investors($projectId: ID!) {
    investors(projectId: $projectId) {
      ...Investor
    }
  }
  ${fragments.investor}
`

export const GET_STAKEHOLDERS = gql`
  query Stakeholders($projectId: ID!) {
    stakeholders(projectId: $projectId) {
      ...Investor
    }
  }
  ${fragments.investor}
`

export const GET_INVESTOR = gql`
  query Investor($investorId: ID!) {
    investor(investorId: $investorId) {
      ...Investor
    }
  }
  ${fragments.investor}
`

export const _SAVE_INVESTOR = gql`
  mutation _SaveInvestor($investorId: ID!, $input: InvestorInput!) {
    _saveInvestor(investorId: $investorId, investorInput: $input) {
      ...Project
    }
  }
  ${fragments.project}
`

export const _DELETE_INVESTOR = gql`
  mutation _DeleteInvestor($investorId: ID!) {
    _deleteInvestor(investorId: $investorId) {
      ...Project
    }
  }
  ${fragments.project}
`
const mutations = {
  addRemote: _ADD_INVESTOR,
  addRemotes: _ADD_INVESTORS,
  saveRemote: _SAVE_INVESTOR,
  deleteRemote: _DELETE_INVESTOR,
  saveOp: '_saveInvestor',
  addOp: '_addInvestor',
  addsOp: 'addInvestors',
  deleteOp: '_deleteInvestor',
}

export const investorsQueries = { ...mutations, getRemote: GET_INVESTORS }
export const investorQueries = { ...mutations, getRemote: GET_INVESTOR }
